import stampDutyTaskTracking from './view/stampDutyTaskTracking.html'

export default {
  base: {
    state: 'declaration.stampDuty.stampDutyTaskTracking',
    config: {
      url: '/stampDutyTaskTracking',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.stampDuty.stampDutyTaskTracking.list',
      title: '申报任务跟踪',
    },
  },
  list: {
    state: 'declaration.stampDuty.stampDutyTaskTracking.list',
    config: {
      url: '/list',
      template: stampDutyTaskTracking,
      controller: 'stampDutyTaskTrackingCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/stampDutyTaskTracking/routers.js